<template>
  <div class="dashboard-wrap" style="position:relative">
    <!-- Spinner -->
    <loading :active="loading" :is-full-page="false" />
    <!-- /Spinner -->
    <b-card no-body-header="header" class="rounded">
      <template #header>
        <b-row>
          <b-col cols="4" class="toggle-align align-items-center">
            <div class="toggle-text">
              With Closed
            </div>
            <div @click="toggleOption" :class="[projectOptionFilterCondition === 'OPEN' ? 'toggle-switch' : 'toggle-switch on']"></div>
          </b-col>  
        </b-row>
        <b-row class="align-items-center">
          <b-col cols="1" class="nowrap">
            <label for="project-option" class="project-option-label">Project</label>
          </b-col>
          <b-col cols="3">
            <select class="form-control project-select-option" @change="changeDashboardData" v-model="projectId"
              name="project-select-option">
              <option value="">All Projects</option>
              <option v-if="project.projectId != ''" v-for="project in filteredProjectOptions" :value="project.projectId">
                {{ project.name }}</option>
            </select>
          </b-col>
        </b-row>
      </template>

      <DashboardRanding v-if="projectId == '' && filteredProjectDashboardData" ref="dashboardRanding"
        :allProjectDashboardData="filteredProjectDashboardData" />

      <template #default v-if="projectId != ''" ref="dashboardCharts">
        <div>
          <b-card-group deck>
            <b-card class="border card-preview">
              <div class="card-header custom-header">
                Project Overview
              </div>
              <ProjectInformationCard v-if="dashboardData" :dashboardData="dashboardData" />
            </b-card>

            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('currentStatusGraph')">
              <div class="card-header custom-header">
                <span>전체 MeMO 상황
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    현재 생성되어 있는 MeMO 들을 아래 설정된 조건에 맞게 통계내어 보여줍니다.<br><br>

                    ※Overdue : Status가 To Do, In Progress 이고, 오늘 날짜가 Due Date를 지난 MeMO 카운트<br>
                    ※On Time : Status가 To Do, In Progress 이고, 오늘 날짜가 Due Date와 같거나 작은 MeMO 카운트<br>
                    ※Done+ : Status가 Done, Cancelled인 MeMO 카운트<br>
                    ※TBD : Status가 To Do, In Progress이고 , Due Date가 설정되지 않은 MeMO 카운트
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['currentStatusGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <CurrentStatusGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false filters='' />
              </div>
            </b-card>

            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('changedYesterdayGraph')">
              <div class="card-header custom-header">
                <span> {{ proceedDate }} 진행한 일
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    마지막 업무일에 변경된 MeMO 들의 개수를 보여줍니다.<br><br>

                    ※To Do : D-1에 마지막으로 Status가 To Do로 변경된 MeMO 카운트<br>
                    ※In Progress : D-1에 마지막으로 Status가 To Do로 변경된 MeMO 카운트<br>
                    ※Done+ : D-1에 마지막으로 Status가 Done, Cancelled로 변경된 MeMO 카운트<br>
                    ※Closed+ : D-1에 마지막으로 Status가 Closed로 변경된 MeMO 카운트
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['changedYesterdayGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ChangedYesterdayGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('changedTodayGraph')">
              <div class="card-header custom-header">
                <span>오늘 한 일
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    오늘 한 일 MeMO 들의 개수를 보여줍니다.<br><br>

                    ※하루에 Status 가 여러번 바뀔 때, 마지막으로 바뀐 Status 로 카운트
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['changedTodayGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ChangedTodayGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false filters='' />
              </div>
            </b-card>
          </b-card-group>
          <b-card-group deck>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectStatusProgressGraph')">
              <div class="card-header custom-header">
                <span>프로젝트 진척도
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    프로젝트 기간동안의 Status 변화 추이를 보여줍니다.<br>

                    ※매일 23:00 기준으로 MeMO 의 상태를 통계내어 저장한 데이터를 사용해 생성<br>
                    ※Done+: Done, Cancelled<br>
                    ※Closed+: Closed
                  </div>
                </span>
                <div
                  :class="showFlexibleGraphConditions['projectStatusProgressGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectStatusProgressGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectPlanAndActualGraph')">
              <div class="card-header custom-header">
                <span>Plan vs Actual
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    프로젝트의 기간별 예상 목표와, 실적을 확인할 수 있습니다.<br><br>

                    ※Plan : MeMO에 기입된 Due Date를 기준으로 카운트<br>
                    ※Actual : 히스토리에 Status가 Done으로 마지막으로 업데이트 된 날짜를 기준으로 카운트
                  </div>
                </span>
                <div
                  :class="showFlexibleGraphConditions['projectPlanAndActualGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectPlanAndActualGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>

            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('completionPeriodGraph')">
              <div class="card-header custom-header">
                <span>MeMO Life-Time 분포
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    MeMO 하나가 생성부터 완료까지의 시간이 얼마나 걸리는지 확인할 수 있습니다.<br><br>

                    ※MeMO 의 생성 날짜, 히스토리에서 MeMO 가 마지막으로 Done 으로 업데이트 된 날짜 사이의 차이를 기준으로 그래프 생성
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['completionPeriodGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <CompletionPeriodGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('chatterActivationGraph')">
              <div class="card-header custom-header">
                <span>오래된 MeMO들
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    업데이트 되지 않고 방치되어있는 MeMO 의 현황을 방치된 날짜별로 확인할 수 있습니다.<br><br>

                    ※생성, 마지막 수정 날짜와, 오늘 날짜의 차이를 기준으로 그래프 생성
                  </div>
                </span>
                <div
                  :class="showFlexibleGraphConditions['chatterActivationGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ChatterActivationGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
          </b-card-group>
          <b-card-group deck>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectManMonthGraph')">
              <div class="card-header custom-header">
                <span>투입 인력
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    프로젝트 기간동안 멤버의 투입, 철수 추이를 역할별로 확인할 수 있습니다.<br><br>

                    ※프로젝트 멤버의 Role In, Role Out, Role 데이터를 기준으로 그래프 생성
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['projectManMonthGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectManMonthGraph if="dashboardData" v-if="dashboardData" :dashboardData="dashboardData"
                  :isFlexible=false filters='' />
              </div>
            </b-card>

            <!-- 23-09-25 생산성 그래프와 보여주는 데이터가 겹치므로 주석 -->
            <!-- <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectOutputGraph')">
                            <div class="card-header custom-header">
                                생산량
                            </div>
                            <div class="card-body p-0  container-graph">
                                <ProjectOutputGraph v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card> -->
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectProductivityGraph')">
              <div class="card-header custom-header">
                <span>생산성
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    투입 인력 대비 생산량을 확인할 수 있습니다.<br><br>

                    ※투입 인력 수 : 투입 중인 프로젝트 멤버 카운트<br>
                                  해당 날짜보다 Role In이 작고 Role Out이 큰 프로젝트 멤버 카운트<br>
                    ※생산량 : 완료한 MeMO 카운트<br>
                            해당 날짜에 Status가 Done으로 업데이트 된 MeMO 카운트<br>
                    ※생산성 : 투입 인력 대비 생산량<br>
                            해당 날짜에 생산량 / 투입 인력 수
                  </div>
                </span>
                <div
                  :class="showFlexibleGraphConditions['projectProductivityGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectProductivityGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph"
              @click="addFlexibleGraph('programCreationDateDistributionGraph')">
              <div class="card-header custom-header">
                <span>날짜별 MeMO 생성 개수
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    프로젝트 기간 중 평균적인 MeMO 의 생성 시기를 확인할 수 있습니다.<br><br>

                    ※MeMO 의 생성 날짜를 기준으로 그래프 생성<br>
                    ※점선 : X 축 모든 날짜에 생성되는 MeMO 평균 개수
                  </div>
                </span>
                <div
                  :class="showFlexibleGraphConditions['programCreationDateDistributionGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProgramCreationDateDistributionGraph v-if="dashboardData" :dashboardData="dashboardData"
                  :isFlexible=false filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('bugReportGraph')">
              <div class="card-header custom-header">
                <span>Bug Report
                  <img class="card-description" :src="require('@/assets/images/question.png')">
                  <div class="description-popup">
                    Type 이 bug, issue, risk 인 MeMO 들을 Level 별로 확인할 수 있습니다.<br><br>

                    ※그래프를 펼치기 전에는 bug, issue, risk 를 한번에 보여주고 펼친 후에는 각각 그래프 생성
                  </div>
                </span>
                <div :class="showFlexibleGraphConditions['bugReportGraph'] ? 'toggle-switch on' : 'toggle-switch'"></div>
              </div>
              <div class="card-body p-0 container-graph">
                <BugReportGraph if="dashboardData" v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
          </b-card-group>
          <!-- <b-card-group deck class="mb-1">
                      <b-card class="border card-preview card-graph" @click="addFlexibleGraph('bugReportGraph')">
                            <div class="card-header custom-header">
                                Bug Report
                            </div>
                            <div class="card-body p-0  container-graph">
                                <BugReportGraph if="dashboardData" v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card>
                        <b-card class="border card-preview card-graph" @click="addFlexibleGraph('programTestDistributionGraph')" >
                            <div class="card-header custom-header">
                                테스트 케이스
                            </div>
                            <div class="card-body p-0  container-graph">
                                <ProgramTestDistributionGraph v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card>
                    </b-card-group> -->
          <b-card-group class="d-flex flex-column card-group-area">
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['currentStatusGraph']" title="전체 MeMO 상황"
              componentName="CurrentStatusGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['changedYesterdayGraph']" :title="proceedDate + ' 진행한 일'"
              componentName="ChangedYesterdayGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['changedTodayGraph']" title="오늘 한 일"
              componentName="ChangedTodayGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectStatusProgressGraph']" title="프로젝트 진척도"
              componentName="ProjectStatusProgressGraph" :dashboardData="dashboardData" filterType="snapshot" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectPlanAndActualGraph']"
              title="Plan vs Actual" componentName="ProjectPlanAndActualGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['completionPeriodGraph']"
              title="MeMO Life-Time 분포" componentName="CompletionPeriodGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['chatterActivationGraph']" title="오래된 MeMO들"
              componentName="ChatterActivationGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectManMonthGraph']" title="투입 인력"
              componentName="ProjectManMonthGraph" :dashboardData="dashboardData" filterType="snapshot" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectOutputGraph']" title="생산량"
              componentName="projectOutputGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectProductivityGraph']" title="생산성"
              componentName="projectProductivityGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['programCreationDateDistributionGraph']"
              title="날짜별 MeMO 생성 개수" componentName="ProgramCreationDateDistributionGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['programTestDistributionGraph']"
              title="테스트 케이스" componentName="ProgramTestDistributionGraph" :dashboardData="dashboardData"
              filterType="history" />

            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['bugReportGraph']" title="Bug Report"
              componentName="bugReportGraph" :dashboardData="dashboardData" filterType="snapshot" />
          </b-card-group>
        </div>
      </template>
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import accessToken from "@/services/accessToken";
import ProjectStatusProgressGraph from './charts2/ProjectStatusProgressGraph.vue';
import ProjectPlanAndActualGraph from './charts2/ProjectPlanAndActualGraph.vue';
import ProjectOutputGraph from './charts2/ProjectOutputGraph.vue';
import ProjectProductivityGraph from './charts2/ProjectProductivityGraph.vue';
import BugReportGraph from './charts2/BugReportGraph.vue';
import CompletionPeriodGraph from './charts2/CompletionPeriodGraph.vue';
import ProgramCreationDateDistributionGraph from './charts2/ProgramCreationDateDistributionGraph.vue';
import CurrentStatusGraph from './charts2/CurrentStatusGraph.vue';
import ChangedYesterdayGraph from './charts2/ChangedYesterdayGraph.vue';
import ChangedTodayGraph from './charts2/ChangedTodayGraph.vue';
import ProjectManMonthGraph from './charts2/ProjectManMonthGraph.vue';
import ChatterActivationGraph from './charts2/ChatterActivationGraph.vue';
import ProjectInformationCard from './charts2/ProjectInformationCard.vue';
import DashboardRanding from './DashboardRanding.vue';
import ChatterFlexibleDashboardCard2 from '@/components/chatter/project/ChatterFlexibleDashboardCard2.vue';
import { integer } from "vee-validate/dist/rules.esm";

import ProgramTestDistributionGraph from './charts2/ProgramTestDistributionGraph.vue';

export default {
  name: "Dashboard",
  components: {
    Loading,
    DashboardRanding,
    ProjectInformationCard,
    ProjectStatusProgressGraph,
    ChatterFlexibleDashboardCard2,
    ProjectPlanAndActualGraph,
    ProjectOutputGraph,
    ProjectProductivityGraph,
    ProgramTestDistributionGraph,
    BugReportGraph,
    CompletionPeriodGraph,
    ProgramCreationDateDistributionGraph,
    CurrentStatusGraph,
    ChangedYesterdayGraph,
    ChangedTodayGraph,
    ProjectManMonthGraph,
    ChatterActivationGraph
  },
  created() {
    // this.projectOptions = this.$store.getters['chatter/projectOptions'];
    this.retrieveDashboard();
  },
  computed: {
    integer() {
      return integer
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    // options() {
    //   const options = 
    //   this.projectOptions = [...options.projectOptions];
    //   return options;
    // },
    projectOptions() {
      return this.$store.getters['chatter/projectOptions'];
    },
    filteredProjectOptions() {
      if(!this.projectOptions) {
        return [];
      }

      if(this.projectOptionFilterCondition === 'ALL') {
        return [...this.projectOptions];
      } else {
        return this.projectOptions.filter((project) => project.status === this.projectOptionFilterCondition);
      }
    },

    filteredProjectDashboardData() {
      const keyArray = Object.keys(this.allProjectDashboardData);    
      
      if (this.projectOptionFilterCondition === 'ALL') {
        return this.allProjectDashboardData;
      } else {  
        let dashboardDataObj = {};

        keyArray.forEach(key => {        
          if(this.allProjectDashboardData[key].projectInfo.status === this.projectOptionFilterCondition) {
            dashboardDataObj[key] = this.allProjectDashboardData[key];
          }
        })

        return dashboardDataObj
      }
    },
    tableData() {
      const data = [];
      const headerLength = this.table.index.length;
      const rowData = {};

      for (const key in this.table) {
        if (key !== "index") {
          for (let i = 0; i < headerLength; i++) {
            rowData[this.table.index[i]] = this.table[key][i];
          }
          data.push(rowData);
        }
      }
      return data;
    },
    proceedDate(){
        let todayDate = new Date(this.today);
        let yesterdayDate = new Date(todayDate);

        yesterdayDate.setDate(yesterdayDate.getDate() - 1);

        let dayOfWeek = yesterdayDate.getDay();


        if(dayOfWeek === 0) {   // 일요일인 경우
              yesterdayDate.setDate(yesterdayDate.getDate() - 2);

        } else if(dayOfWeek === 6) {    // 토요일인 경우
              yesterdayDate.setDate(yesterdayDate.getDate() - 1);
        }

          this.yesterdayDate = yesterdayDate;

          return yesterdayDate.toISOString().slice(0, 10);

    }
  },
  data() {
    return {
      projectOptionFilterCondition: 'OPEN',
      projectId: '',
      projectName: '',
      loading: false,
      projectInformation: [],
      dashboardImageList: [],
      descriptionList: ["Description", "Period"],
      columnName: {
        projectId: "ID",
        projectType: "Type",
        name: "Name",
        description: "Description",
        startDate: "Start Date",
        endDate: "End Date"
      },
      yearList: [],
      monthlyInfo: [],
      energyUseSeries: [{
        name: "Working Days",
        data: ""
      }],
      allProjectDashboardData: '',
      dashboardData: '',
      showFlexibleGraphConditions: {
        projectStatusProgressGraph: false,
        projectPlanAndActualGraph: false,
        projectOutputGraph: false,
        projectProductivityGraph: false,
        programTestDistributionGraph: false,
        bugReportGraph: false,
        completionPeriodGraph: false,
        programCreationDateDistributionGraph: false,
        currentStatusGraph: false,
        changedYesterdayGraph: false,
        changedTodayGraph: false,
        projectManMonthGraph: false,
        chatterActivationGraph: false,
      }
    }
  },
  methods: {
    retrieveDashboard() {
      try {
        this.loading = true;

        if (this.projectId == '') {
          axios.get('chatter/retrieveDashboardData', {
            headers: { Accept: 'application/json', Authorization: accessToken() }
          }).then(response => {
            this.allProjectDashboardData = response.data;
            this.loading = false;
          });
        }
      } catch (e) {
        this.showEeror(e);
        this.loading = false;
      } finally {
      }
    },
    changeDashboardData() {
      this.loading = true;

      this.dashboardData = '';
      Object.keys(this.showFlexibleGraphConditions).forEach(key => {
        this.showFlexibleGraphConditions[key] = false;
      });

      setTimeout(() => {
        this.dashboardData = this.allProjectDashboardData[this.projectId];
        this.loading = false;
      }, 1000);      
    },

    addFlexibleGraph(graphName) {
      this.showFlexibleGraphConditions[graphName] = !this.showFlexibleGraphConditions[graphName];
    },

    handleChangeProjectOptionsFilter() {
      // this.projectOptions = options.projectOptions.filter((project) => project.status === this.projectOptionFilterCondition);
      // this.$refs.dashboardRanding.for
      // console.log(this.$refs.dashboardRanding);
    },
    toggleOption() {
      this.projectOptionFilterCondition = (this.projectOptionFilterCondition === 'ALL') ? 'OPEN' : 'ALL';
    }
  },
}

</script>
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
</style>

<style>
.dashboard-wrap .card.rounded {
  margin-bottom: 3.125vw;
  border-radius: 30px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.dashboard-wrap .card.rounded>.card-header {
  padding: 30px 0;
  margin: 0 2.0833vw;
}

.dashboard-wrap .card.rounded>.card-body {
  padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
}

.dashboard-wrap .container-graph {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-wrap .card-deck {
  margin-right: -10px;
  margin-left: -10px;
}

.dashboard-wrap .card-deck .card {
  padding: 1px;
  border-radius: 10px;
}

.dashboard-wrap .card-deck .card-preview {
  margin: 10px;
}

.dashboard-wrap .card .card-header {
  padding-top: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6 !important;
  color: #2E2E38;
  font-family: NanumGothic;
  font-size: clamp(14px, 0.9375vw, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.dashboard-wrap .card-preview .card-header {
  display: flex;
  justify-content: space-between;
  height: 57px;
  padding-top: 18px;
  padding-right: 0;
}

.dashboard-wrap .card-preview .card-body {
  height: calc(100% - 57px);
}

.dashboard-wrap .card-graph {
  padding: 1px;
  cursor: pointer;
  border: 1px solid #dee2e6 !important;
}

.dashboard-wrap .card-graph:hover {
  border: 1px solid #747480 !important;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10);
}

.dashboard-wrap .content-text {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical
}

.dashboard-wrap .project-option-label {
  font-size: 30px;
}

.dashboard-wrap .project-select-option {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  margin-bottom: 0;
  height: 50px;
  border-radius: 10px;
  color: #2E2E38;
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 12px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  appearance: none;
}

.nowrap[class*="col-"] {
  width: max-content;
  max-width: unset;
  white-space: nowrap;
}

.apexcharts-canvas {
  position: static !important;
}

.apexcharts-canvas svg {
  overflow: visible;
}

.apexcharts-legend-marker {
  width: 8px !important;
  height: 8px !important;
}

.toggle-align{
  display: flex;
  margin-left: 10px;
  gap: 10px;
  margin-left: 22%;
}

.toggle-text{
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
}

.toggle-switch {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  background: #DDDDE3;
  transition: 0.3s;
}

.toggle-switch.on {
  background: #142459;
}

.toggle-switch::after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  border-radius: 50%;
  background-color: #fff;
  width: 16px;
  height: 16px;
  transition: 0.3s;
}

.toggle-switch.on::after {
  transform: translateX(100%);
}

.card-group-area {
  gap: 24px;
}

.card-group-area .card {
  border-radius: 10px !important;
}

.card-group-area .card:first-child {
  position: relative;
  margin-top: min(110px, calc(6.25vw - 10px));
}

.card-group-area .card:first-child::before {
  content: '';
  display: block;
  position: absolute;
  top: min(-53px, -2.7604vw);
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #C4C4CD;
}

.card-group-area .card .card-header {
  height: 60px;
  padding: 1.066rem 1.333rem;
  border-radius: 10px 10px 0 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

.card-group-area .card .card-header .container-fluid {
  padding: 0;
}

.card-group-area .card .card-header .row {
  margin: 0;
}

.card-group-area .card .card-header .btn-filter-fold {
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  background-color: transparent;
}

.card-group-area .card .card-header .btn-filter-fold:active {
  color: inherit;
  background-color: transparent;
  border-color: transparent;
}

.card-group-area .card .card-header .btn-filter-fold:focus {
  box-shadow: none;
}

.card-group-area .card .card-body {
  position: relative;
  padding: 0 !important;
}

.card-preview {
  min-height: max(35vh, 380px);
}

.card-description{
  width: 15px;
}

.description-popup {
  display: none;
  position: absolute;
  width: 300px;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f9f9f9;
  padding: 10px;
  z-index: 1;
  font-size: 10px;
}

.card-description:hover + .description-popup {
  display: block;
}
</style>